import React, { Fragment, lazy } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import Auth from 'Auth'
import Zendesk from 'Auth/Zendesk'
import { ShellRoute } from 'App/Shell'
import FourOFour from 'App/FourOFour'
import Checkout from 'Checkout'
import HomeRouter from 'HomePage/HomeRouter'
import ProductDetailPage from 'Catalog/Product/ProductDetail/ProductDetailPageContainer'
import { ProductCategory } from 'features/ProductCategory'
import { Store, StoreVoucher } from 'features/Store'
import { Modal } from 'loyal-react'
import { ConfirmationCreditMileage } from 'features/Services/ConfirmationCreditMileage'
import { MyOrders, ProductOrderDetail } from 'Participant/MyOrders'
import { Confirmation } from 'features/Confirmation'
import {
  AddressPage,
  ProfilePage,
  ExtractPage,
  ChangePassword,
  SecurityAccessPage,
  TokenChangeEmailPage,
  TwoStepVerificationPage,
  FaqTwoStep
} from 'Participant'
import { Scheduling } from 'Participant/Scheduling'
import { Orders, Order } from 'features/User/Orders'

import { WishlistPage } from 'Participant/Wishlist'

import { ConfirmationDonation } from 'features/ConfirmationDonation'
import { Cellphonerecharge } from 'features/CellphoneRecharge'

import { BillPaymentContainer } from 'features/BillPayment'
import { MileageContainer } from 'features/MileageRescue'
import { FuelCreditContainer } from 'features/FuelCredit'
import { DonationContainer } from 'features/Donation'
import { PointsAndCash } from 'features/PointsAndCash'
import { CartContainer } from 'features/Cart'
import { ConfirmationMobileRechargeSchedule } from 'features/ConfirmationMobileRechargeSchedule'
import { SearchPage, SearchVendor, ShowCase } from 'Catalog/Search'

import Benefits from 'features/Benefits'
import RedirectCustom from 'features/RedirectCustom/RedirectCustom'

const Terms = lazy(() => import('features/Terms/Terms'))
const RegulationPage = lazy(() => import('features/Regulation/RegulationPage'))
const Privacy = lazy(() => import('features/Privacy/Privacy'))
const Security = lazy(() => import('features/Security/Security'))

const AppRouter = () => (
  <Fragment>
    <Switch>
      <Route path='/zendesk' component={Zendesk} />
      <Route path='/auth' component={Auth} />
      <Route path='/' exact component={HomeRouter} />
      <ShellRoute path='/checkout' component={Checkout} />
      <ShellRoute path='/products/:sku' component={ProductDetailPage} />
      <ShellRoute path='/categories' component={ProductCategory} />
      <ShellRoute
        path='/services/confirmation/:orderId'
        component={ConfirmationCreditMileage}
      />
      <ShellRoute path='/stores/vouchers' component={StoreVoucher} />
      <ShellRoute path='/stores' component={Store} />
      <ShellRoute path='/my-orders' component={MyOrders} />
      <ShellRoute
        path='/order/:parentOrderId/:orderId/product/:productId'
        component={ProductOrderDetail}
      />
      <ShellRoute path='/confirmation/:orderId' component={Confirmation} />
      <ShellRoute
        path='/two-step-verification'
        component={TwoStepVerificationPage}
      />
      <ShellRoute path='/faq-two-step' component={FaqTwoStep} />
      <ShellRoute path='/modal' component={Modal} />
      <ShellRoute path='/scheduling' component={Scheduling} />
      <ShellRoute path='/orders' component={Orders} />
      <ShellRoute path='/order' component={Order} />
      <ShellRoute
        path='/my-account/change-password'
        component={ChangePassword}
      />
      <ShellRoute path='/security-access' component={SecurityAccessPage} />
      <ShellRoute path='/token-change-email' component={TokenChangeEmailPage} />
      <ShellRoute path='/wishlist' component={WishlistPage} />
      <ShellRoute path='/my-address' component={AddressPage} />
      <ShellRoute path='/extract' component={ExtractPage} />
      <ShellRoute path='/profile' component={ProfilePage} />
      <ShellRoute path='/mobile-recharge' component={Cellphonerecharge} />
      <ShellRoute
        path='/confirmation-donation'
        component={ConfirmationDonation}
      />
      <ShellRoute path='/pointsandcash' component={PointsAndCash} />
      <ShellRoute path='/billpayment' component={BillPaymentContainer} />
      <ShellRoute path='/fuelcredit' component={FuelCreditContainer} />
      <ShellRoute path='/donation' component={DonationContainer} />
      <ShellRoute path='/mileage' component={MileageContainer} />
      <ShellRoute path='/showcase' component={ShowCase} />
      <ShellRoute path='/search' component={SearchPage} />
      <ShellRoute path='/vendor' component={SearchVendor} />
      <ShellRoute
        path='/mobile-recharge/confirmation/:scheduleId'
        component={ConfirmationMobileRechargeSchedule}
      />
      <ShellRoute path='/cart' component={CartContainer} />
      <ShellRoute path='/terms' component={Terms} isGuest />
      <ShellRoute path='/regulation' component={RegulationPage} isGuest />
      <ShellRoute path='/privacy' component={Privacy} isGuest />
      <ShellRoute path='/security' component={Security} isGuest />
      <ShellRoute path='/benefits' component={Benefits} />
      <Route path='/redirect' component={RedirectCustom} />
      <Route path='/purchase-points'>
        <Redirect to='/checkout/points-purchase' />
      </Route>
      <Route path='/guest'>
        <Redirect to='/' />
      </Route>
      <ShellRoute component={FourOFour} isGuest />
    </Switch>
  </Fragment>
)

export default AppRouter



// WEBPACK FOOTER //
// ./src/App/AppRouter.js